import React from 'react'
import * as S from './LegendStyles'
import { LegendItem } from 'types/RuntimeHistory'
import { SelectedLegends } from '.'

type IndoorFiltersProps = {
  data: Array<Required<LegendItem>>;
  selectedLegends: SelectedLegends;
  onFilterSelectionChanged: (seriesName: string, isChecked: boolean) => void;
}

const IndoorFilters = ({
  data,
  selectedLegends,
  onFilterSelectionChanged
}: IndoorFiltersProps) => {
  const isIndoorSelected = (legendItem) => {
    const isSelected = selectedLegends.zoneSeries
      ?.map((zone) => zone.series?.includes(legendItem.seriesName))
      .includes(true)
    return !!(selectedLegends.zoneSeries && isSelected)
  }

  return (
    <S.NonZoneSection>
      <S.Typography>Indoor</S.Typography>
      <S.CheckboxGroup>
        {data?.map((indoor) => {
          return (
            <S.FilterCheckbox
              key={indoor.seriesName}
              label={indoor.label}
              listId="indoor"
              checked={isIndoorSelected(indoor)}
              onChange={(e) =>
                onFilterSelectionChanged(
                  indoor.seriesName,
                  e.target.checked
                )
              }
            />
          )
        })}
      </S.CheckboxGroup>
    </S.NonZoneSection>
  )
}

export default IndoorFilters
